let buildVersion: string = null;
let needsUpdate: boolean = false;

/****************************************************************************
 * Build Version
 ****************************************************************************/

export const setBuildVersion = (version: string) => {
    localStorage.setItem('pc_build_version', version);
};

export const getBuildVersion = () => {
    if (!buildVersion) {
        buildVersion = localStorage.getItem('pc_build_version');
    }

    return buildVersion;
};

/****************************************************************************
 * Flag to Check whether app reload is required
 ****************************************************************************/

export const setBuildUpdateFlag = (flag: boolean) => {
    needsUpdate = flag;
};

export const getBuildUpdateFlag = () => {
    return needsUpdate;
};
